import React from "react";
import { useTranslation } from "react-i18next";
import {
  Title,
  RevFlexSection,
  FlexSection,
  FullWidthSection,
  FullWidthImage,
  ImageSubtitle
} from "./styles";
import { ResponsiveImage } from "components/ResponsiveImage";
import { ContentDiv } from "components/containers";
import { StyledButton } from "components/generic";
import { useNavigate } from "react-router-dom";
import { BLOG_ROUTE, REGISTER_ROUTE } from "../../../utils/constants";
import { useIsMobile } from "../../../utils/hooks/useWindowSize";
import { OrangePlayFull } from "components/Icons/OrangePlayFull"
import { HeaderSEO } from "components/headerSEO";
import { ISeo } from "interfaces/intarfaces";


export const Mission: React.FC = () => {
  const { t, i18n } = useTranslation("mission");
  const navigate = useNavigate();

  const isMobile = useIsMobile();

  const [textWidth, setTextWidth] = React.useState<string>("225px");

  React.useEffect(() => {
    if (isMobile) {
      setTextWidth("160px")
    } else {
      setTextWidth("225px")
    }
  }, [isMobile]);
  const seo = t("mission.seo", { returnObjects: true }) as ISeo;

  return (
    <ContentDiv>
      {seo && <HeaderSEO {...seo} />}
      <Title>{t("mission.title")}</Title>
      <OrangePlayFull viewView={textWidth} viewHeight="16px" marginBottom="1em" strokeWidth="8"/>
      <RevFlexSection>
        <ResponsiveImage
          imgSrc={"rootpage/mission/Hospita en student drinken thee"}
          className={"image"}
          mobileSize={"95vw"}
          tabletSize={"30vw"}
          desktopSize={"40vw"}
        />
        <div>
          <h3>{t("mission.missionSection.header")}</h3>
          <h2>{t("mission.missionSection.title")}</h2>
          <p>{t("mission.missionSection.description")}</p>
        </div>
      </RevFlexSection>
      <section>
        <FullWidthImage>
          <ResponsiveImage
            imgSrc={"rootpage/mission/Hospita en studenten in tuin in Leiden"}
            className={"image"}
            mobileSize={"200vw"}
            tabletSize={"200vw"}
            desktopSize={"200vw"}
          />
        </FullWidthImage>
        <ImageSubtitle>{t("mission.photoSubtitle")}</ImageSubtitle>
      </section>
      <RevFlexSection>
        <ResponsiveImage
          imgSrc={
            "rootpage/mission/Daan Donkers met hospita Ana Lucia in Colombia"
          }
          className={"missionimage"}
          mobileSize={"95vw"}
          tabletSize={"30vw"}
          desktopSize={"40vw"}
        />
        <div>
          <h3>{t("mission.originSection.header")}</h3>
          <h2>{t("mission.originSection.title")}</h2>
          <p>{t("mission.originSection.description")}</p>
          <StyledButton
            onClick={() =>
              navigate(`/${i18n.language}${BLOG_ROUTE.slice(5)}/kamertekort-en-het-ontstaan-van-hospi-housing`)
            }
          >
            {t("mission.originSection.button")}
          </StyledButton>
        </div>
      </RevFlexSection>
      <FlexSection>
        <ResponsiveImage
          imgSrc={
            "rootpage/mission/Hospita en student aan keukentafel in Groningen"
          }
          className={"image"}
          mobileSize={"95vw"}
          tabletSize={"30vw"}
          desktopSize={"40vw"}
        />
        <div>
          <h3>{t("mission.revivalSection.header")}</h3>
          <h2>{t("mission.revivalSection.title")}</h2>
          <p>{t("mission.revivalSection.description")}</p>
        </div>
      </FlexSection>
      <FullWidthSection>
        <h3>{t("mission.enrichingSection.header")}</h3>
        <h2>{t("mission.enrichingSection.title")}</h2>
        <p>{t("mission.enrichingSection.description")}</p>
        <hr />
        <span>Daan Donkers - Founder</span>
      </FullWidthSection>
      <RevFlexSection lastMember>
        <ResponsiveImage
          imgSrc={
            "rootpage/press/Oprichters Hospi Housing Joost Daan en Maurits op bankje in tuin"
          }
          className={"missionimage"}
          mobileSize={"95vw"}
          tabletSize={"30vw"}
          desktopSize={"40vw"}
        />
        <div>
          <h3>{t("mission.joinSection.header")}</h3>
          <h2>{t("mission.joinSection.title")}</h2>
          <p>{t("mission.joinSection.description")}</p>
          <StyledButton
            onClick={() =>
              navigate(`/${i18n.language}${REGISTER_ROUTE.slice(5)}`)
            }
          >
            {t("mission.joinSection.button")}
          </StyledButton>
        </div>
      </RevFlexSection>
    </ContentDiv>
  );
};
